import React from "react";
import { Navigate } from "react-router-dom";

export default function RouteWrapper({ isPrivate = false, children }) {
  const signed = !!localStorage.getItem("_t");

  if (isPrivate && !signed) {
    return <Navigate to="/" />;
  }

  if (!isPrivate && signed) {
    return <Navigate to="/dashboard/assistants" />;
  }

  return children;
}
